var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavUserProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#ff6262;opacity:0;}.b{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18177 23704)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18838 -24067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M688,372h-8v-1a3,3,0,0,0-6,0v1h-8a2,2,0,0,0-2,2v12a2,2,0,0,0,2,2h22a2,2,0,0,0,2-2V374A2,2,0,0,0,688,372Zm1,14a1,1,0,0,1-1,1H666a1,1,0,0,1-1-1V374a1,1,0,0,1,1-1h9v-2a2,2,0,0,1,4,0v2h9a1,1,0,0,1,1,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 1,
    transform: "translate(678 375)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1,
    transform: "translate(678 377)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 1,
    transform: "translate(678 380)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 1,
    transform: "translate(678 382)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 1,
    transform: "translate(678 384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.886,380.315a3,3,0,1,0-3.772,0A4.671,4.671,0,0,0,666,385h10A4.671,4.671,0,0,0,672.886,380.315ZM669,378a2,2,0,1,1,2,2A2,2,0,0,1,669,378Zm-1.9,6a4.039,4.039,0,0,1,7.806,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(676 370)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-18177 -23704)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavUserProfile);
export default __webpack_public_path__ + "static/media/nav-user-profile.5e84f658b7d11b738af4a40e369eed76.svg";
export { ForwardRef as ReactComponent };